<ion-header>
  <ion-toolbar color="white">
    <ion-buttons slot="start">
      <ion-menu-button *ngIf="showMenuBtn">
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
      <ion-button (click)="goMainPage()" *ngIf="!showMenuBtn">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.help' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="white">
  <div class="content-div">
    <div class="ion-text-center">
      <ion-img class="center img" src="./assets/wedding/img/support/support.svg"></ion-img>
    </div>
    <div class="ion-padding-horizontal ion-padding-bottom ion-margin-bottom">
      <ion-grid fixed>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="openHelpCenter()" button>
              {{ 'MENU.help_center' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goContactPage()" button>
              {{ 'MENU.contact' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goAppDownloadPage()" button>
              {{ 'APP_DOWNLOAD.title' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goAppRatingPage()" button>
              {{ 'APP_RATING.title' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goAppUpdatePage()" button>
              {{ 'APP_UPDATE.title' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goReferralPage()" button>
              {{ 'MENU.referral' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goPrivacyPage()" button>
              {{ 'MENU.privacy' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goTermPage()" button>
              {{ 'MENU.term' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="goAupPage()" button>
              {{ 'AUP.title' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-card class="ion-no-margin ion-padding" color="light" (click)="openWebsite()" button>
              {{ 'COMPANY.website' | translate }}
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</ion-content>